import Support from './Support.view';

export default Support;
